var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.src)?_c('div',{class:_vm.componentClass,style:(_vm.style)}):_c('div',{class:_vm.componentClass},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.defaultIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }